class LsgUpsellProducts extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            slider: 'js-lsg-upsell-products-slider',
            sliderArrowPrev: 'js-lsg-upsell-products-slider-arrow-prev',
            sliderArrowNext: 'js-lsg-upsell-products-slider-arrow-next',
        };
    }

    connectedCallback() {
        this.slider = this.querySelector(`.${this.classes.slider}`);

        this.initSlider();
        this.setupRecommendations();
    }

    initSlider() {
        if (!this.slider) return;

        const $slider = $(this.querySelector(`.${this.classes.slider}`));
        if (!$slider.length) return;
        const $arrowPrev = $(this.querySelector(`.${this.classes.sliderArrowPrev}`));
        const $arrowNext = $(this.querySelector(`.${this.classes.sliderArrowNext}`));

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $arrowPrev,
            nextArrow: $arrowNext,
        });
    }

    setupRecommendations() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;

            observer.unobserve(this);

            const url = this.dataset.url;

            fetch(url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('.lsg-upsell-products');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;

                        // Reinitialize the slider after replacing the content
                        this.slider = this.querySelector(`.${this.classes.slider}`);
                        this.initSlider();
                    }
                })
                .catch((e) => console.error('Error fetching recommendations:', e));
        };

        const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(this);
    }
}

const customElementName = 'lsg-upsell-products';
if (!customElements.get(customElementName)) {
    window.customElements.define(customElementName, LsgUpsellProducts);
}
